<template>
  <div class="page-content">
    <div class="d-block justify-content-center">
      <div class="row">
        <div class="col-md-12">
          <div class="page-heading">
            <h2>Invite Partners</h2>
            <button class="btn btn-success" @click="downloadPartnerExcelData">
              <i class="bi bi-file-earmark-spreadsheet-fill"></i>
            </button>
            <div class="date-holder">
              <Datepicker
                v-model="dateRange"
                range
                :enableTimePicker="false"
                placeholder="Select Date Range"
              />
            </div>
            <partner-invite-filter
              @getAllData="searchHandler"
              :registered_by="uniqueRegisteredByNames"
            ></partner-invite-filter>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="d-flex justify-content-center">
      <partner-invite @getAllData="searchHandler"></partner-invite>
    </div> -->

    <div class="mt-4">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <DefaultLoader v-if="isLoading"></DefaultLoader>
              <template v-else-if="partners.length > 0">
                <InvitePartnerDatatable
                  :partners="partners"
                  :drivers="driverDetails"
                  @sendPaginationCount="setPaginationLength"
                  @refreshPaginationData="getPaginationData"
                />
                <!-- Paginate -->
                <div class="row" v-if="showPagination === 'Yes'">
                  <div class="col-md-6">
                    <p>
                      Showing {{ this.from }} to {{ this.to }} of
                      {{ this.total }} entries
                    </p>
                  </div>
                  <div class="col-md-6">
                    <Paginate
                      :totalPages="totalPages"
                      :total="total"
                      :currentPage="currentPage"
                      :perPage="perPage"
                      v-on:pagechanged="getPaginationData"
                    ></Paginate>
                  </div>
                </div>
              </template>
              <NoDataMessage v-else></NoDataMessage>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import PartnerInvite from '../components/invitePartner/InvitePartner';
import PartnerInviteFilter from '../components/invitePartner/InvitePartnerFilter';
import InvitePartnerDatatable from '../components/invitePartner/InvitePartnerDatatable';
import Paginate from '../components/pagination/Pagination';
import http from '../config/axios';
import userService from '../config/axiosUserService.js';
import Datepicker from '@vuepic/vue-datepicker';

export default {
  name: 'Partners',
  components: {
    // PartnerInvite,
    PartnerInviteFilter,
    InvitePartnerDatatable,
    Paginate,
    Datepicker
  },
  data() {
    return {
      shuttlePartnerFilter: [],
      partners: [],
      driverDetails: [],
      isLoading: true,
      totalPages: 0,
      total: 0,
      currentPage: 1,
      perPage: 0,
      pageCount: '',
      to: 0,
      from: 0,
      searchObject: {
        partner_type: '',
        car_model: '',
        car_type: '',
        drop_location: '',
        garage_location: '',
        status: '',
        pagination: '',
        user_id: '',
        start_date: null,
        end_date: null
      },
      setPaginationValue: '100',
      showPagination: 'No',
      uniqueRegisteredByNames: [],
      dateRange: null,
      tzoffset: new Date().getTimezoneOffset() * 60000
    };
  },
  mounted() {
    this.searchHandler();
    this.getPaginationData(1, true);
    this.setPaginationLength();
  },
  watch: {
    dateRange: function () {
      this.searchObject.start_date = null;
      this.searchObject.end_date = null;
      if (this.dateRange && this.dateRange.length > 0) {
        this.searchObject.start_date = this.dateRange[0];
        this.searchObject.end_date = this.dateRange[1];
      }
      this.getPaginationData();
    }
  },
  methods: {
    /**
     *
     * @param data
     */
    searchHandler(data) {
      this.searchObject.partner_type =
        data && Object.keys(data).length ? data.partner_type : [''];
      this.searchObject.car_model =
        data && Object.keys(data).length ? data.car_model : [''];
      this.searchObject.car_type =
        data && Object.keys(data).length ? data.car_type : [''];
      this.searchObject.drop_location =
        data && Object.keys(data).length ? data.drop_location : [''];
      this.searchObject.garage_location =
        data && Object.keys(data).length ? data.garage_location : [''];
      this.searchObject.is_driven_by =
        data && Object.keys(data).length ? data.is_driven_by : [''];
      this.searchObject.registered_by =
        data && Object.keys(data).length ? data.registered_by : [''];
      this.searchObject.status =
        data && Object.keys(data).length ? data.status : [''];
      this.searchObject.role =
        data && Object.keys(data).length ? data.role : '';
      this.searchObject.tags =
        data && Object.keys(data).length ? data.tags : '';
      this.searchObject.pagination = this.setPaginationValue
        ? this.setPaginationValue
        : '100';
      this.searchObject.user_id =
        data && Object.keys(data).length ? data.user_code : [''];

      this.getPaginationData();
    },
    mapUniqueRegisteredByName() {
      this.uniqueRegisteredByNames = [];
      this.partners.forEach((ele) => {
        if (
          ele.registered_by &&
          !this.uniqueRegisteredByNames.includes(ele.registered_by)
        ) {
          this.uniqueRegisteredByNames.push(ele.registered_by);
        }
      });
    },
    /**
     *
     * @param data
     */
    getPaginationData(data = 1, mapRegisteredBy = false) {
      this.isLoading = true;
      http
        .post(
          `v2/partners/triprequests/invitations/search?page=${data}&pagination=${this.searchObject.pagination}`,
          this.searchObject
        )
        .then((response) => {
          this.isLoading = false;
          if (response.status === 200) {
            this.partners = response.data.data.data;
            let partner_id = [];
            // this.partners.forEach((object) => {
            //   partner_id.push(object.id);
            //   // partner_id = [...new Set(partner_id)];
            // });
            this.partners.map((partner) => {
              partner_id.push(partner.user_id);
            });
            if (mapRegisteredBy) {
              this.mapUniqueRegisteredByName();
            }
            partner_id = [...new Set(partner_id)];
            for (let ind = 0; ind < partner_id.length; ind++) {
              let codes = partner_id.splice(ind, 100);
              userService
                .get(
                  `v1/users?user_code=${codes.join(
                    ','
                  )}&fields=name,mobile,user_code,email,status,role&system=Partner App&limit=100`
                )
                .then((response) => {
                  // this.driverDetails = [
                  //   ...this.driverDetails,
                  //   ...response.data.data
                  // ];
                  this.driverDetails = response.data.data;
                })
                .catch((error) => {
                  console.log(error);
                });
              ind--;
            }
            this.total = response.data.data.total;
            this.totalPages = response.data.data.last_page;
            this.currentPage = response.data.data.current_page;
            this.perPage = response.data.data.per_page;
            this.to = response.data.data.to;
            this.from = response.data.data.from;

            setTimeout(() => {
              this.showPagination = 'Yes';
            }, 2000);
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
          this.isLoading = false;
        });
    },
    /**
     *
     * @param data
     */
    setPaginationLength(data) {
      this.setPaginationValue = data;
      // this.searchObject.pagination=data;
      this.searchHandler();
    },
    downloadPartnerExcelData() {
      let startDate = null;
      let endDate = null;
      if (this.dateRange && this.dateRange.length > 0) {
        startDate = new Date(this.dateRange[0] - this.tzoffset)
          .toISOString()
          .substring(0, 10);
        endDate = new Date(this.dateRange[1] - this.tzoffset)
          .toISOString()
          .substring(0, 10);
      }
      var url;
      url = `v2/partners/triprequests/invitations/export?start_date=${startDate}&end_date=${endDate}`;
      document.getElementById('globalLoadingModalBtn').click();

      http
        .get(url, { responseType: 'arraybuffer' })
        .then((response) => {
          setTimeout(() => {
            document.getElementById('globalLoadingModalBtn').click();
          }, 200);
          const url = URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            `attendance_${startDate}_${endDate}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          document.getElementById('globalLoadingModalBtn').click();
          console.log(error);
          this.errored = true;
        });
    }
  }
};
</script>

<style scoped>
.partner-pagination {
  position: relative;
  top: -80px;
}
.date-holder {
  float: right;
  width: 250px;
  margin: 0 15px;
}
</style>
